var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "r/icon/success"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 94,
    cy: 94,
    r: 94,
    fill: "#1AB394",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 94,
    cy: 94,
    r: 73,
    fill: "#1AB394",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 94,
    cy: 94,
    r: 53,
    fill: "#1AB394",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "checkbox-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M108.16 84.2031C108.623 84.5444 108.722 85.1965 108.38 85.6596L93.797 105.451C93.6288 105.68 93.375 105.829 93.0939 105.866C92.8129 105.903 92.529 105.824 92.3076 105.647L81.891 97.3135C81.4418 96.9541 81.3689 96.2986 81.7283 95.8493C82.0877 95.4001 82.7432 95.3273 83.1924 95.6867L92.7627 103.343L106.703 84.4238C107.044 83.9607 107.696 83.8619 108.16 84.2031Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.27fc05fe1f5afa09e6c030cb8ec47dea.svg";
export { ForwardRef as ReactComponent };